import { Injectable, OnDestroy } from '@angular/core';
import { OfficerDetailFacade } from '@intrensic/shared/officer-details';
import { PreviewUserHeadingServiceBase, UserHeading } from '@shared/feature/page-layout';
import { UserRole } from '@shared/utils/base-auth';
import { Observable, Subject, combineLatest, map, startWith } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PreviewUserHeadingService extends PreviewUserHeadingServiceBase implements OnDestroy {
  private imageChangeSubject = new Subject<string | null>();

  constructor(private currentOfficer: OfficerDetailFacade) {
    super();
  }

  override getUserData(): Observable<UserHeading> {
    const officer$ = this.currentOfficer
      .getLoggedInOfficer()
      .pipe(
        map(
          (officer) =>
            new UserHeading(`${officer.firstName} ${officer.lastName}`, officer.role, officer.picturePath, officer.uid, officer.userUIConfiguration.isNotificationBannerRead)
        )
      );

    return combineLatest([officer$, this.imageChangeSubject.pipe(startWith<string | null>(null))]).pipe(
      map(([userHeading, imageUrl]) => {
        if (imageUrl) {
          userHeading.imageUrl = imageUrl.concat(`?t=${Date.now()}`);
        }

        return userHeading;
      })
    );
  }

  override userImageChanged(value: string | null): void {
    this.imageChangeSubject.next(value);
  }

  override getUserRole(): Observable<UserRole> {
    return this.currentOfficer.getLoggedInOfficer().pipe(map((user) => user.role));
  }

  ngOnDestroy(): void {
    this.imageChangeSubject.next(null);
    this.imageChangeSubject.complete();
  }
}
